module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "edit-location"
  }, [_c('div', {
    staticClass: "edit-location-form form"
  }, [_c('div', {
    staticClass: "edit-location-content"
  }, [(_vm.batchEdition) ? _c('div', [_c('strong', [_c('h4', [_vm._v("Editing " + _vm._s(_vm.selectedEntities.length) + " items")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.batchEdition) ? _c('div', {
    staticClass: "pull-left mb-4"
  }, [_c('select', {
    staticClass: "form-control",
    staticStyle: {
      "min-width": "200px"
    }
  }, _vm._l((_vm.selectedEntities), function(item) {
    return _c('option', [_vm._v(_vm._s(item.id) + " - " + _vm._s(item.address.streetAddress) + ", " + _vm._s(item.address.addressLocality) + ", " + _vm._s(item.address.addressRegion) + " " + _vm._s(item.address.postalCode))])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-right mb-4"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.closeEdit
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (!_vm.dynShowPublishingAlert) ? _c('button', {
    staticClass: "btn btn-primary btn-md ml-4 b-4",
    attrs: {
      "disabled": _vm.batchEdition && !_vm.batchButtonEnabled
    },
    on: {
      "click": _vm.saveDataLocalBusiness
    }
  }, [(_vm.batchEdition) ? _c('span', [_vm._v("Update " + _vm._s(_vm.selectedEntities.length) + " items")]) : _vm._e(), _vm._v(" "), (_vm.newEntity) ? _c('span', [_vm._v("Save New Location")]) : _vm._e(), _vm._v(" "), (!_vm.newEntity && !_vm.batchEdition) ? _c('span', [_vm._v("Save Location Updates")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.dynShowPublishingAlert) ? _c('button', {
    staticClass: "btn btn-primary btn-md ml-4 b-4 btn-outline-primary disabled"
  }, [(_vm.batchEdition) ? _c('span', [_vm._v("Update " + _vm._s(_vm.selectedEntities.length) + " items")]) : _vm._e(), _vm._v(" "), (_vm.newEntity) ? _c('span', [_vm._v("Save New Location")]) : _vm._e(), _vm._v(" "), (!_vm.newEntity && !_vm.batchEdition) ? _c('span', [_vm._v("Save Location Updates")]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body edit-location-address-info"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.isLocalBusinessFieldVisible('name')) ? _c('text-input', {
    attrs: {
      "validationRule": _vm.validationRuleForLocalBusinessField('name'),
      "inputId": "name",
      "label": "Name"
    },
    model: {
      value: (_vm.editLocalBusiness.name),
      callback: function($$v) {
        _vm.$set(_vm.editLocalBusiness, "name", $$v)
      },
      expression: "editLocalBusiness.name"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.isLocalBusinessFieldVisible('branchCode')) ? _c('text-input', {
    attrs: {
      "validationRule": "required|branchcode",
      "inputId": "branchCode",
      "label": "Store code"
    },
    model: {
      value: (_vm.editLocalBusiness.branchCode),
      callback: function($$v) {
        _vm.$set(_vm.editLocalBusiness, "branchCode", $$v)
      },
      expression: "editLocalBusiness.branchCode"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.isLocalBusinessFieldVisible('description')) ? _c('text-input', {
    attrs: {
      "inputId": "description",
      "label": "Description"
    },
    model: {
      value: (_vm.editLocalBusiness.description),
      callback: function($$v) {
        _vm.$set(_vm.editLocalBusiness, "description", $$v)
      },
      expression: "editLocalBusiness.description"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.isLocalBusinessFieldVisible('telephone')) ? _c('fax-number-input', {
    attrs: {
      "validationRule": _vm.validationRuleForLocalBusinessField('telephone'),
      "inputId": "telephone",
      "label": "Phone"
    },
    model: {
      value: (_vm.editLocalBusiness.telephone),
      callback: function($$v) {
        _vm.$set(_vm.editLocalBusiness, "telephone", $$v)
      },
      expression: "editLocalBusiness.telephone"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.isLocalBusinessFieldVisible('address')) ? _c('postal-address', {
    attrs: {
      "addressRegion": _vm.editLocalBusiness.address.addressRegion,
      "addressLocality": _vm.editLocalBusiness.address.addressLocality,
      "streetAddress": _vm.editLocalBusiness.address.streetAddress,
      "postalCode": _vm.editLocalBusiness.address.postalCode,
      "addressCountry": _vm.editLocalBusiness.address.addressCountry,
      "street2": _vm.editLocalBusiness.additionalProperty,
      "showLatLong": true,
      "longitude": _vm.editLocalBusiness.geo.longitude,
      "latitude": _vm.editLocalBusiness.geo.latitude
    },
    on: {
      "update:addressRegion": function($event) {
        _vm.$set(_vm.editLocalBusiness.address, "addressRegion", $event)
      },
      "update:addressLocality": function($event) {
        _vm.$set(_vm.editLocalBusiness.address, "addressLocality", $event)
      },
      "update:streetAddress": function($event) {
        _vm.$set(_vm.editLocalBusiness.address, "streetAddress", $event)
      },
      "update:postalCode": function($event) {
        _vm.$set(_vm.editLocalBusiness.address, "postalCode", $event)
      },
      "update:addressCountry": function($event) {
        _vm.$set(_vm.editLocalBusiness.address, "addressCountry", $event)
      },
      "update:street2": function($event) {
        _vm.$set(_vm.editLocalBusiness, "additionalProperty", $event)
      },
      "update:longitude": function($event) {
        _vm.$set(_vm.editLocalBusiness.geo, "longitude", $event)
      },
      "update:latitude": function($event) {
        _vm.$set(_vm.editLocalBusiness.geo, "latitude", $event)
      }
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), (_vm.isLocalBusinessFieldVisible('additionalProperty')) ? _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body "
  }, [_c('additional-props', {
    attrs: {
      "inputId": "additionalProperty",
      "label": "Advanced Information",
      "valid-props": _vm.getAddPropsSpec()
    },
    model: {
      value: (_vm.editLocalBusiness.additionalProperty),
      callback: function($$v) {
        _vm.$set(_vm.editLocalBusiness, "additionalProperty", $$v)
      },
      expression: "editLocalBusiness.additionalProperty"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.isLocalBusinessFieldVisible('logo')) ? _c('remote-image', {
    attrs: {
      "inputId": "logo",
      "label": "Logo"
    },
    model: {
      value: (_vm.editLocalBusiness.logo),
      callback: function($$v) {
        _vm.$set(_vm.editLocalBusiness, "logo", $$v)
      },
      expression: "editLocalBusiness.logo"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.isLocalBusinessFieldVisible('photo')) ? _c('remote-image', {
    attrs: {
      "inputId": "photo",
      "label": "Photo"
    },
    model: {
      value: (_vm.editLocalBusiness.photo),
      callback: function($$v) {
        _vm.$set(_vm.editLocalBusiness, "photo", $$v)
      },
      expression: "editLocalBusiness.photo"
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.isLocalBusinessFieldVisible('openingHoursSpecification')) ? _c('runtime-hours', {
    attrs: {
      "inputId": "openingHoursSpecification",
      "label": "Store Hours",
      "data-vv-name": "openingHoursSpecification",
      "showDayOfWeek": true,
      "showAllDaysOfWeek": true,
      "showToggleDay": _vm.batchEdition,
      "showPopulateMatchesButton": _vm.batchEdition
    },
    on: {
      "daytoggle": _vm.toggleBatchDay
    },
    model: {
      value: (_vm.editLocalBusiness.openingHoursSpecification),
      callback: function($$v) {
        _vm.$set(_vm.editLocalBusiness, "openingHoursSpecification", $$v)
      },
      expression: "editLocalBusiness.openingHoursSpecification"
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.isLocalBusinessFieldVisible('specialOpeningHoursSpecification')) ? _c('runtime-hours', {
    attrs: {
      "inputId": "specialOpeningHoursSpecification",
      "label": "Holiday Hours",
      "data-vv-name": "specialOpeningHoursSpecification",
      "showValidFrom": true,
      "showDescription": true,
      "showBatchClearSwitch": _vm.batchEdition,
      "batch-location-count": this.selectedEntities.length,
      "showPopulateMatchesButton": _vm.batchEdition
    },
    model: {
      value: (_vm.editLocalBusiness.specialOpeningHoursSpecification),
      callback: function($$v) {
        _vm.$set(_vm.editLocalBusiness, "specialOpeningHoursSpecification", $$v)
      },
      expression: "editLocalBusiness.specialOpeningHoursSpecification"
    }
  }) : _vm._e()], 1)])])])])])]), _vm._v(" "), _c('modal', {
    staticClass: "modal-danger",
    attrs: {
      "title": "Modal title",
      "effect": "fade/zoom"
    },
    on: {
      "ok": _vm.saveBatchEditFieldsPromise
    },
    model: {
      value: (_vm.confirmModal),
      callback: function($$v) {
        _vm.confirmModal = $$v
      },
      expression: "confirmModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Are you sure you want to update these " + _vm._s(this.selectedEntities.length) + " Locations?")])]), _vm._v("\n    The following fields will be updated:\n    "), _c('ul', _vm._l((_vm.batchEditFieldsApplied), function(item) {
    return _c('li', {
      key: item
    }, [_vm._v("\n       " + _vm._s(item) + "\n    ")])
  })), _vm._v("\n    This cannot be undone.\n    "), (this.showProgress) ? _c('div', {
    staticClass: "progress"
  }, [_c('progressbar', {
    attrs: {
      "now": this.progress,
      "label": "",
      "type": "primary",
      "striped": "",
      "animated": ""
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('alert', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "show": _vm.dynShowPublishingAlert,
      "placement": "top",
      "number": "0",
      "type": "danger",
      "width": "380px",
      "dismissable": ""
    },
    on: {
      "update:show": function($event) {
        _vm.dynShowPublishingAlert = $event
      }
    },
    model: {
      value: (_vm.dynShowPublishingAlert),
      callback: function($$v) {
        _vm.dynShowPublishingAlert = $$v
      },
      expression: "dynShowPublishingAlert"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong'), _vm._v(" "), _c('p', [_vm._v("Location editing is disabled during Publishing")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Location Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Additional Properties")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Images")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Store Hours")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Holiday Hours")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-079d9d1f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/EditLocalBusiness.vue
// module id = 537
// module chunks = 1